import { Response } from "@/api/client";
import { useSnackbarStore } from "@/store/snackbar.store";
import { usePipStore } from "@/store/pip.store";

export function useError() {
  function showAPIError(
    response: Response<any>,
    defaultMessage = "",
    snackbarOptions = {
      timeout: -1,
    },
  ) {
    const { showSnackbarError } = useSnackbarStore();

    showSnackbarError(getAPIErrorMessage(response) ?? defaultMessage, snackbarOptions.timeout);
  }

  function getAPIErrorMessage(response: Response<unknown>): string | null {
    const detail = response.errorData?.detail;

    if (Array.isArray(detail) && detail.length > 0) {
      return detail[0]?.msg ?? null;
    }

    if (typeof detail === "string") {
      return detail;
    }

    return null;
  }

  function scrollToError(container?: ParentNode | null) {
    const pipStore = usePipStore();
    const roots = [container, pipStore.pipContainer, document].filter((root): root is ParentNode => Boolean(root));

    for (const root of roots) {
      const element = root.querySelector(".v-field--error:first-of-type");

      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });

        return;
      }
    }
  }

  return {
    showAPIError,
    getAPIErrorMessage,
    scrollToError,
  };
}
